import { BaseOwnerEntity } from "../entity/baseOwnerEntity";

export class DevicePreference extends BaseOwnerEntity {
  id?: number;
  deviceId?: number;
  shortCode?: string;
  value?: string;
}
